/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type InTheLastValueConfigKind = (typeof InTheLastValueConfigKind)[keyof typeof InTheLastValueConfigKind];

export const InTheLastValueConfigKind = {
  in_the_last: 'in_the_last',
} as const;
